module.exports = __webpack_public_path__ + "media/images/case-studies/bfc_logo_square-47d7f12c83996da614634dd35bcc941e.png";